// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1QeX3","checkboxCol":"Table_checkboxCol__37hIo","emailCol":"Table_emailCol__3Pz6g","actionCol":"Table_actionCol__10Fy0"};